import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { BeneficiariesPage } from '@egw/features-settings'

export const SettingsBeneficiariesPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <BeneficiariesPage />
    </Layout>
  )
}
